import React from 'react';

const SetProductsTabButtons = ({
	productsOfSet = [],
	onChangeTabOfSetMember,
	activeSetMemberId,
	submittedSetMembers
}) => {
	return (
		<ul>
			{productsOfSet.map((member, index) => (
				<li
					key={member?.id}
					className={`${activeSetMemberId === member.id ? 'active' : ''}`}
					onClick={() => onChangeTabOfSetMember(member, index)}
				>
					{submittedSetMembers.includes(member.id) && (
						<span className="pr-2">
							<img
								src={`${process.env.PUBLIC_URL}/icons/Success.svg`}
								alt=""
								className="select"
							/>
						</span>
					)}
					{member.name !== 'Finish' && 'TNA for'} {member?.name}
				</li>
			))}
		</ul>
	);
};

export default SetProductsTabButtons;
